export default {
  isDateInRange(dateStr = null) {
   // 如果没有传递日期字符串，则使用当前日期
   const date = dateStr ? new Date(dateStr) : new Date();
 
   
 
   // 确保时间是当天的00:00:00，以便只比较日期部分
   const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
   console.log(startOfDay);
   // 设置边缘日期，并转换为时间戳
   const startDate = new Date(date.getFullYear(),5,24).getTime(); // 6月24日
   const endDate = new Date(date.getFullYear(), 7, 31).getTime();   // 8月31日
   console.log(startDate);
   console.log(endDate);
   // 由于我们只关心日期部分，所以将给定日期的时间部分设置为00:00:00后的时间戳
   // 然后与边缘日期的时间戳进行比较
   return startOfDay >= startDate && startOfDay <= endDate;
},
  luqufangshi(fen1, num1, fen2, num2) {
    let fenshu = fen1 * num1 + fen2 * num2;
    let fen = fenshu.toFixed(1);
    let strNum = fen.toString();
    let fen3=''

    // 检查字符串是否包含小数点
    if (strNum.includes(".")) {
      // 分割字符串为整数部分和小数部分
      let [integerPart, decimalPart] = strNum.split(".");

      // 去除小数部分末尾的零
      decimalPart = decimalPart.replace(/0+$/, "");

      // 如果小数部分变为空字符串，并且原始数字不是整数（即不是.0形式），则返回整数部分
      // 注意：这里我们检查原始字符串是否以'.0'结尾来避免将1.0转换为1（如果这是不期望的）
      if (decimalPart === "" && !strNum.endsWith(".0")) {
        fen3= parseInt(integerPart, 10); // 返回整数
      } else {
        // 否则重新组合整数部分和小数部分（如果小数部分不为空）
        fen3= decimalPart === ""
          ? integerPart
          : integerPart + "." + decimalPart;
      }
    }else{
        fen3=fen
    }
    let ltem={
      fentxt:`${fen1} × ${num1} + ${fen2} × ${num2}=${fen3}`,
      zong:fen3
    }

    return ltem
  },
  addjudge(array, key = 'ischeck', value = false) {

		return array.map(obj => {
			if (typeof obj !== 'object' || obj === null) {
				console.warn(`数组中的某个元素不是对象，无法添加参数: ${JSON.stringify(obj)}`);
				return obj; // 保留原样
			}
			return {
				...obj, // 使用展开运算符复制原对象
				[key]: value // 添加预设的新参数
			};
		});
	},
};
